import { useEffect, useState } from "react";
import { Download, CheckCircle2, MoreVertical, Share } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !/crios|fxios/i.test(navigator.userAgent);

export function InstallAppButton({ light = false, className = "" }) {
  const [evt, setEvt] = useState(() => window.__gaInstallEvt || null);
  const [installed, setInstalled] = useState(isStandalone);
  const [help, setHelp] = useState(false);

  useEffect(() => {
    const onReady = () => setEvt(window.__gaInstallEvt || null);
    const onInstalled = () => { window.__gaInstallEvt = null; setEvt(null); setInstalled(true); toast.success("Clicou, Guardou! instalado. Procure o ícone na sua tela inicial."); };
    window.addEventListener("ga-install-ready", onReady);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("ga-install-ready", onReady); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (installed) {
    return <div className={`flex items-center justify-center gap-2 text-sm font-medium ${className}`} style={{ color: light ? "#33D9B2" : "#0A6373" }} data-testid="install-app-installed"><CheckCircle2 size={16} /> App instalado</div>;
  }

  const install = async () => {
    if (!evt) return setHelp(true);
    try {
      evt.prompt();
      const { outcome } = await evt.userChoice;
      window.__gaInstallEvt = null; setEvt(null);
      if (outcome === "accepted") toast.success("Instalando o Clicou, Guardou!...");
      else toast("Tudo bem. Você pode instalar depois pelo botão BAIXAR O APP.");
    } catch (_) { setHelp(true); }
  };

  return (
    <>
      <button type="button" onClick={install} className={`flex w-full items-center justify-center gap-2 rounded-full py-3 text-sm font-bold uppercase tracking-wide transition-transform active:scale-[0.98] ${className}`}
        style={light ? { background: "rgba(255,255,255,.12)", color: "#fff", border: "1px solid rgba(51,217,178,.6)" } : { background: "#05324A", color: "#33D9B2" }} data-testid="install-app-button">
        <Download size={18} /> Baixar o app
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="w-[calc(100vw-2rem)] max-w-sm rounded-3xl p-5" data-testid="install-help-dialog">
          <DialogTitle>Instalar o Clicou, Guardou!</DialogTitle>
          <DialogDescription className="text-sm">Seu navegador não abriu a instalação automática. Faça assim:</DialogDescription>
          <div className="space-y-3 text-sm">
            {isIos() ? (
              <div className="ga-surface flex items-start gap-3 rounded-2xl p-3" data-testid="install-help-ios"><Share size={18} className="mt-0.5 shrink-0" style={{ color: "#0A6373" }} /><div><b>iPhone / Safari</b><br />Toque em <b>Compartilhar</b> → <b>Adicionar à Tela de Início</b>.</div></div>
            ) : (
              <div className="ga-surface flex items-start gap-3 rounded-2xl p-3" data-testid="install-help-android"><MoreVertical size={18} className="mt-0.5 shrink-0" style={{ color: "#0A6373" }} /><div><b>Android / Chrome</b><br />Toque no menu <b>⋮</b> → <b>Adicionar à tela inicial</b> ou <b>Instalar app</b>.</div></div>
            )}
          </div>
          <button onClick={() => setHelp(false)} className="ga-btn-primary w-full" data-testid="install-help-close">Entendi</button>
        </DialogContent>
      </Dialog>
    </>
  );
}
